module.exports = __webpack_public_path__ + "static/media/cmn_title.4efa6c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cmn_title.png
// module id = 1626
// module chunks = 1